
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormContainer from '../../commons/forms/FormContainer.vue'
import CharField from '../../commons/fields/CharField.vue'
import TextFieldEditor from '../../commons/fields/TextFieldEditor.vue'
import { IPSWhatWeNeedForm, IPSWhatWeNeedFormErrors } from '@/types/processingSteps'
import DocumentField from '@/components/processing_steps/commons/fields/DocumentField.vue'
import { IPhoto } from '@/types/photos'
import NavigationLinks from '@/components/navigation_link/NavigationLinks.vue'
import { INavigationLink } from "@/types/foerderApp"

@Component({
  components: {
    FormContainer,
    CharField,
    TextFieldEditor,
    DocumentField,
    NavigationLinks
  }
})
export default class WhatWeNeed extends Vue {
  @Prop() noTitle!: boolean
  @Prop({ default: () => Vue.prototype.$gettext("What we need") }) stepTitle!: string
  @Prop() form!: IPSWhatWeNeedForm
  @Prop() formErrors!: IPSWhatWeNeedFormErrors
  @Prop({ required: true }) uploadUrl!: string | null
  @Prop({ required: true }) documentUploadUrl!: string | null
  @Prop({ default: () => [] }) existingPhotos!: IPhoto[]
  @Prop({ default: () => [] }) existingDocuments!: IPhoto[]
  @Prop({ default: 'project' }) instanceType!: 'project' | 'organization'

  get stepDesc (): string {
    return this.$gettext('All information and media that you enter or upload here will be made available to potential sponsors. Our tip: The more appealing and clearer your information and media are, the better you will present yourself to sponsors and decision-makers.')
  }

  get fieldDescDescription (): string | null {
    if (this.instanceType === 'organization') {
      return this.$gettext('The detailed organizational description serves to present your organization in a comprehensive manner. It gives sponsors a clear picture of who you are, what you do, and how you work. It describes, for example, the structure, history, services, and target groups of your organization.')
    }
  }

  get fieldDescPhotos (): string | null {
    if (this.instanceType === 'organization') {
      return this.$gettext('Upload photos or videos of your organization here. Show who you are and what you stand for. Pictures of your team, your activities, or your location build trust and provide insights into your work. If possible, also upload a video introducing your organization and your projects.')
    }
    return this.$gettext('Upload images or videos of your project here. Choose emotional and appealing images that emphasize the message and goal of your project. High-quality photos help to attract attention and bring your project to life.')
  }

  get fieldDescLinks (): string {
    if (this.instanceType === 'organization') {
      return this.$gettext('Link here to your website or to public appearances of your organization. You can also link your organization\'s social media accounts here (Instagram, Facebook, etc.)')
    }
    return this.$gettext('Link here to your website or to public appearances of your project. You can also link your organization\'s social media accounts here (Instagram, Facebook, etc.)')
  }

  get fieldDescDocuments (): string | null {
    if (this.instanceType === 'organization') {
      return this.$gettext('Upload documents (.pdf, .jpg, .png) relating to your organization that are of interest to potential sponsors - for example a press snippet or an award.')
    }
    return this.$gettext('Upload documents (.pdf, .jpg, .png) relating to your project that are of interest to potential sponsors here - for example a press snippet or an award.')
  }

  updateLinks(updatedLinks: INavigationLink[]) {
    this.$set(this.form, 'links', updatedLinks)
  }
}
